// Base URL for the Express API. Empty string in local dev (CRA's "proxy"
// setting in package.json forwards /api/* to the local backend). Set to the
// deployed backend's URL in production, since frontend and backend live on
// different hosts (Hostinger + Render).
export const API_URL = process.env.REACT_APP_API_URL || '';
